function TrustBadges({ className = "" }) {
  return (
    <div
      className={`trust-badges small text-center ${className}`.trim()}
      role="note"
      aria-label="Store guarantees"
    >
      <span className="trust-badges__item">100% authentic</span>
      <span className="trust-badges__sep" aria-hidden>
        ·
      </span>
      <span className="trust-badges__item">Easy returns</span>
      <span className="trust-badges__sep" aria-hidden>
        ·
      </span>
      <span className="trust-badges__item">Secure checkout</span>
    </div>
  );
}

export default TrustBadges;
